// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.i1EhZ318O_gW32fW{display:flex;align-items:center;margin-right:auto}.i1EhZ318O_gW32fW .Dp2KhTe_bv0qXx5w{padding:2px;font-size:9px;align-self:flex-start;color:var(--py-primary-9);opacity:.7}.i1EhZ318O_gW32fW .Dp2KhTe_bv0qXx5w:hover{opacity:1}.i1EhZ318O_gW32fW .ve4fzmvgqv4YYxvI{height:14px;padding-left:6px}.i1EhZ318O_gW32fW .J0ZHUljO0A8BR257{text-decoration:none}.i1EhZ318O_gW32fW .J0ZHUljO0A8BR257:hover{text-decoration:underline;cursor:pointer}.EOXMpnV00IEowwNf{margin-top:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `i1EhZ318O_gW32fW`,
	"infoIcon": `Dp2KhTe_bv0qXx5w`,
	"titleImage": `ve4fzmvgqv4YYxvI`,
	"labelLink": `J0ZHUljO0A8BR257`,
	"errorMessage": `EOXMpnV00IEowwNf`
};
export default ___CSS_LOADER_EXPORT___;
